import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import LineChartBase from "components/charts/LineChartBase";



const AttendanceTrend = () => {
const data = [
    { month: "Jan", percentage: 95 },
    { month: "Feb", percentage: 90 },
    { month: "Mar", percentage: 95.7 },
    { month: "Apr", percentage: 95.2 },
    { month: "May", percentage: 95.7 },
    { month: "Jun", percentage: 90.5 },
];

  return (
    <HeaderComponent
      title="Attendance Trend"
      description="Monthly attendance rate percentage over 6 months"
    >
      <LineChartBase 
        data={data}
        xKey="month"
        height={300}
        yKey="percentage"
        domain={[85, 100]}
        yFormatter={(v) => `${v}%`}
        tooltipFormatter={(value) => [`${value}%`, "Attendance Rate"]}
        textSize={14} 
      />
    </HeaderComponent>
  );
};

export default AttendanceTrend;
